/**
 * ColorTemperature Style01 - Slider
 * min/max from attributes.colorTemperatureRange
 */
import { useState, useEffect, useMemo } from 'react'
import type { TraitControlProps } from './types'
import { resolveRangeFromAttributes } from './traitStyleConfig'
import './ColorTemperatureStyle01.css'

export function ColorTemperatureStyle01({
  trait,
  state,
  attributes,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const { min: MIN, max: MAX } = useMemo(
    () => resolveRangeFromAttributes(attributes, trait, 'colorTemperature'),
    [attributes, trait]
  )
  const raw = (state?.colorTemperature ?? state?.color_temp ?? state?.temperature) as number | undefined
  const current = typeof raw === 'number' ? Math.max(MIN, Math.min(MAX, Math.round(raw))) : Math.round((MIN + MAX) / 2)
  const [temp, setTemp] = useState(current)

  useEffect(() => {
    const v = typeof raw === 'number' ? Math.max(MIN, Math.min(MAX, Math.round(raw))) : Math.round((MIN + MAX) / 2)
    setTemp(v)
  }, [raw, MIN, MAX])

  const handleChange = (value: number) => {
    const clamped = Math.max(MIN, Math.min(MAX, Math.round(value)))
    setTemp(clamped)
    void onCommand('setColorTemperature', { temperature: clamped })
  }

  return (
    <div className="trait-colortemp-style01">
      <label htmlFor="colortemp-style01-slider" className="trait-colortemp-style01__label">
        ColorTemperature
      </label>
      <input
        id="colortemp-style01-slider"
        type="range"
        min={MIN}
        max={MAX}
        value={temp}
        onChange={(e) => setTemp(Number(e.target.value))}
        onMouseUp={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        onTouchEnd={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        className="trait-colortemp-style01__slider"
        disabled={disabled}
        style={{
          background: `linear-gradient(to right, #ff9a56 0%, #fff5e6 50%, #e3f2fd 100%)`,
        }}
      />
      <span className="trait-colortemp-style01__value">{temp}K</span>
    </div>
  )
}
